import { Component, OnInit } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-complete-pattern-two-player',
  templateUrl: './complete-pattern-two-player.component.html',
  styleUrls: ['./complete-pattern-two-player.component.css']
})
export class CompletePatternTwoPlayerComponent extends GeneralExerciseComponent implements OnInit {

  isLeaved = false;
  pattern: number[];
  isCompleteEndExercise: boolean;
  isPatternCreatePartVisible: boolean;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.initValues();
  }

  initValues() {
    this.isLeaved = false;
    this.pattern = [];
    this.solved = false;
    this.isPatternCreatePartVisible = true;
  }

  checkSolution() {
  }

  setPattern(pattern: number[]) {
    this.pattern = pattern;
    console.log(this.pattern);
    this.isPatternCreatePartVisible = false;
  }

  setSolved(isSolved) {
    this.solved = isSolved;
    this.checkSolution();
  }

  setCorrect(isCorrect: boolean) {
    if (isCorrect) {
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlySolved'), 'danger', 2000);
    }
  }

  setLeaveRoom(isLeaved: boolean) {
    this.isLeaved = isLeaved;
  }

  generateNextExercise() {
    this.initValues();

    this.counter ++;
  }

  computeState() {
  }

  setTypeSpecificsFromConfiguration() {
    this.isCompleteEndExercise = this.configuration.typespecifics.isCompleteEndExercise;
  }

  setTypeSpecificsFromState() {
  }
}
